import { Action, createReducer, on } from "@ngrx/store";
import * as _ from "lodash";

import { MpAdminActions } from "../../actions/mp-admin.actions";
import { ConsumerBalancesState } from "../../models/mp-admin/consumer-balances-state";

const initialState: ConsumerBalancesState = {
	loading: true
};

const reducer = createReducer(
	initialState,
	on(MpAdminActions.consumerBalances.getApi, (state) =>
		_.set(_.cloneDeep(state), "loading", true)
	),
	on(MpAdminActions.consumerBalances.getSuccess, (state, action) => _.omit(action, "type")),
	on(MpAdminActions.consumerBalances.getFail, (state, action) =>
		_.merge(_.cloneDeep(state), _.omit(action, "type"))
	)
);

export function consumerBalancesReducer(
	state: ConsumerBalancesState,
	action: Action
): ConsumerBalancesState {
	return reducer(state, action);
}
